import type UIAnalyticsEvent from '@atlaskit/analytics-next/UIAnalyticsEvent';

export function handleAnalyticsEvents(objectId: string) {
	return (event: UIAnalyticsEvent): void => {
		event.update((payload) => ({
			...payload,
			attributes: {
				...payload.attributes,
				objectId,
			},
		}));
	};
}
